import React from "react";
import "./skins.css";

function payloadRows(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return [];
  }
  return Object.entries(payload).slice(0, 4);
}

export default function SensorRulesSkin({ rules = [], latestPayload }) {
  const latestRows = payloadRows(latestPayload);
  return (
    <section className="skin-card sensor-rules-skin">
      <header className="skin-card__header">
        <h3>감시 조건</h3>
      </header>
      <div className="skin-card__body">
        {latestRows.length ? (
          <div className="rules-latest">
            {latestRows.map(([key, value]) => (
              <span key={key}>{key}: {String(value)}</span>
            ))}
          </div>
        ) : null}
        {!rules.length ? (
          <div className="skin-empty-inline">감시 조건이 없습니다.</div>
        ) : (
          <div className="rules-list">
            {rules.map((rule, index) => (
              <article className="rule-item" key={`${rule.sensor_key || "rule"}-${index}`}>
                <strong>{rule.sensor_key || `조건 ${index + 1}`}</strong>
                <div className="rule-item__meta">
                  <span>{rule.comparison_operator || "-"}</span>
                  <span>{rule.threshold_value || "-"}</span>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
